import { render, staticRenderFns } from "./3_InputListQuestion.vue?vue&type=template&id=36094471&scoped=true&"
import script from "./3_InputListQuestion.vue?vue&type=script&lang=js&"
export * from "./3_InputListQuestion.vue?vue&type=script&lang=js&"
import style0 from "./3_InputListQuestion.vue?vue&type=style&index=0&id=36094471&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36094471",
  null
  
)

export default component.exports